
import TopHeader from "../Layouts/TopHeader.vue";
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeOne/MainBanner.vue";
import EasySolution from "../HomeOne/EasySolution.vue";
import BestServices from "../HomeOne/BestServices.vue";
// import HowItWorks from "../HomeOne/HowItWorks.vue";
import WhyChooseUs from "../HomeOne/WhyChooseUs.vue";
// import GalleryExhibition from "../HomeOne/GalleryExhibition.vue";
import OurDoctors from "../HomeOne/OurDoctors.vue";
import Psihology from "../HomeOne/Psihology.vue";
// import PeopleAlsoAsk from "../HomeOne/PeopleAlsoAsk.vue";
// import OurTestimonials from "../HomeOne/OurTestimonials.vue";
// import OurPricing from "../HomeOne/OurPricing.vue";
// import OurPartner from "../HomeOne/OurPartner.vue";
// import LatestNews from "../HomeOne/LatestNews.vue";
// import KeepInTouch from "../HomeOne/KeepInTouch.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeOnePage",
  components: {
    TopHeader,
    MainNavbar,
    MainBanner,
    EasySolution,
    BestServices,
    // HowItWorks,
    WhyChooseUs,
    // GalleryExhibition,
    OurDoctors,
    Psihology,
    // PeopleAlsoAsk,
    // OurTestimonials,
    // OurPricing,
    // OurPartner,
    // LatestNews,
    // KeepInTouch,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
